import React from "react";

function Arc({ color = "grey", radius, width, start }) {
  const circumference = radius * 2 * Math.PI;
  const arc = circumference * 0.5;
  const dashArray = `${arc} ${circumference}`;
  const transformAngle = 180 + (start * 180) / 100;

  const transform = `rotate(${transformAngle}, ${radius}, ${radius})`;
  const offset = arc - (width / 100) * arc;

  return (
    <svg
      height={radius}
      width={radius * 2}
      className="gauge-container__arc-line"
    >
      <circle
        cx={radius}
        cy={radius}
        stroke={color}
        r={radius}
        strokeWidth={6}
        fill="transparent"
        strokeDasharray={dashArray}
        strokeDashoffset={offset}
        transform={transform}
      />
    </svg>
  );
}

export default Arc;
